import { useEffect, useState } from "react";
import {
  Text,
  Flex,
  Box,
  Button,
  useDisclosure,
  Image,
} from "@chakra-ui/react";
import InstructionModal from "components/instructionModal";
import Table from "components/table";
import MainLayout from "components/mainLayout";
import MakeARequestModal from "./Modal";
import { columns } from "./data";
import useGetRequests from "api/queries/useGetRequests";
import { useUserContext } from "context/UserContext";
import ViewModal from "./ViewModal";
import Topbar from "components/topbar";
import CustomSelect from "components/select";
import Searchbar from "components/searchbar";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";
import HeaderDropdown from "components/dropdown";

const Requests = () => {
  const { user } = useUserContext();
  const {
    isOpen: isFormOpen,
    onOpen: onFormOpen,
    onClose: onFormClose,
  } = useDisclosure();
  const {
    isOpen: isInstructionOpen,
    onOpen: onInstructionOpen,
    onClose: onInstructionClose,
  } = useDisclosure();

  const [selectedRow, setSelectedRow] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [requestsData, setRequestsData] = useState([]);
  const [sort, setSort] = useState(SORT_NEWEST_FIRST);
  const [search, setSearch] = useState("");

  const requestsQuery = useGetRequests(user?.info?._id, sort, search);

  useEffect(() => {
    const data = requestsQuery?.data?.data;
    if (!data) return;
    console.log("data==>", data);
    setRequestsData(data);
  }, [requestsQuery?.data]);

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setIsViewModalOpen(true);
  };

  const handleSearchChange = (val) => {
    setSearch(val);
  };

  const handleSortChange = (val) => {
    setSort(val);
  };

  return (
    <MainLayout>
      <Box h={"100%"} minH={"100vh"} paddingBottom={20}>
        <Box>
          <Flex
            bg="white"
            padding={8}
            align={"center"}
            justify={"space-between"}
          >
            <Flex alignItems={"center"}>
              <Text
                fontFamily={"PlusJakartaSansBold"}
                fontSize={"16px"}
                lineHeight={"16px"}
                textTransform={"uppercase"}
              >
                Requests
              </Text>
              <Image
                src={require("assets/svgs/info-circle.svg").default}
                pos={"relative"}
                bottom={"1px"}
                mx={2}
                _hover={{
                  cursor: "pointer",
                }}
              />
            </Flex>
            <Flex gap={2} justifyContent={"flex-end"}>
              <Button
                onClick={() => onFormOpen()}
                w={"140px"}
                py={6}
                bg={"#1C1C1C"}
                borderRadius={"12px"}
                color={"white"}
                textTransform={"capitalize"}
                alignSelf={"flex-end"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansBold"}
              >
                <Image
                  src={require("assets/svgs/plus.svg").default}
                  width={"16px"}
                  height={"16px"}
                  pos={"relative"}
                  mr={1}
                  _hover={{
                    cursor: "pointer",
                  }}
                />
                Make a Request
              </Button>
              <HeaderDropdown />
            </Flex>
          </Flex>
        </Box>
        <Flex bg={"#f8fbff"} padding={4} height={"100%"} gap={2}>
          <Flex flex={1} direction={"column"} padding={4}>
            <Flex justify={"space-between"} alignItems={"center"} mb={4}>
              <Flex align={"center"}>
                <Searchbar onChange={handleSearchChange} title={"Search"} />
              </Flex>
              <CustomSelect
                label={"Sort"}
                onChange={handleSortChange}
                style={{ maxWidth: "200px" }}
                inputStyle={{
                  border: "none",
                  background: "#fff",
                  color: "#898989",
                  fontSize: "14px",
                  fontFamily: "PlusJakartaSansMedium",
                }}
              >
                <option value={SORT_NEWEST_FIRST}>Newest First</option>
                <option value={SORT_OLDEST_FIRST}>Oldest First</option>
              </CustomSelect>
            </Flex>
            <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
              <Table columns={columns(handleViewClick)} data={requestsData} />
            </Box>
          </Flex>
        </Flex>
        {isFormOpen && (
          <MakeARequestModal onClose={onFormClose} isOpen={isFormOpen} />
        )}
        {isViewModalOpen && (
          <ViewModal
            isOpen={isViewModalOpen}
            onClose={() => setIsViewModalOpen(false)}
            request={selectedRow}
          />
        )}
        <InstructionModal
          isOpen={isInstructionOpen}
          onClose={onInstructionClose}
        />
      </Box>
    </MainLayout>
  );
};

export default Requests;
